  <template>
  <div class="wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>微信小程序接入</span>
        </div>
      </h3>
    </el-header>
    <el-scrollbar class="scrollbar-wrap">
      <el-container v-show="step == 1">
        <el-main>
          <el-row type="flex" justify="center">
            <el-col class="max-block" :span="20">
              <h4>请在小程序后台：“开发”——“开发设置”中获取以下信息</h4>
              <el-form :rules="rules" :model="channelSet" ref='form' label-width="250px">
                <el-form-item label="小程序名称:" prop="name">
                  <el-input v-model="channelSet.name"></el-input>
                </el-form-item>
                <el-form-item label="AppID（小程序ID）:" prop="appId">
                  <el-input v-model="channelSet.appId"></el-input>
                </el-form-item>
                <el-form-item label="AppSercet（小程序秘钥）:" prop="appSecret">
                  <el-input v-model="channelSet.appSecret"></el-input>
                </el-form-item>
                <!-- <el-form-item label="启用智能机器人:">
                <el-select v-model="channelSet.bot">
                  <el-option v-for="item in bots"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
                <!-- <el-form-item label="是否开启转人工触发词">
                <el-radio-group v-model="channelSet.triggerOn">
                  <el-radio :label='true'>是</el-radio>
                  <el-radio :label='false'>否</el-radio>
                </el-radio-group>
              </el-form-item> -->
                <el-form-item label="转人工触发词:" prop="triggerWord" v-show="channelSet.triggerOn">
                  <el-input v-model="channelSet.triggerWord" placeholder="例如：人工，转人工"></el-input>
                  <el-tooltip class="item" content="1.可设置多个，多个触发词用英文逗号隔开：2.需要全部命中触发词，如：触发词为”转人工“则必须输入”转人工“才能转入人工" placement="right">
                    <el-button type="text" size="small">
                      <svg class="icon icon-warning" aria-hidden="true">
                        <use xlink:href="#icontixing" />
                      </svg>
                    </el-button>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="欢迎语:" prop="greeting">
                  <el-input v-model="channelSet.greeting" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="路由策略:">
                  <div class="d-flex">
                    <el-row type="flex" justify="space-between">
                      <el-col :span="10">
                        <el-select v-model="channelSet.routeStrategy">
                          <el-option v-for="item in strategies" :key="item.id" :label="item.acdName" :value="item.id"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item size="medium">
                  <el-row type="flex" justify="center">
                    <el-button size="medium" @click="cancel">取 消</el-button>
                    <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <el-container v-show="step == 2">
        <el-main>
          <el-row type="flex" justify="center">
            <el-col class="max-block" :span="17">
              <el-alert title="温馨提示：请先保存当前设置后再将“Token”以及“EncodingAESey“应用到绑定的微信公众平台后台" type="warning" :closable="false" show-icon>
              </el-alert>
              <el-form :rules="rules" ref="ruleForm" :model="channelSet" label-width="135px" size="medium">
                <ul class="docking-deploy">
                  <li>
                    <div class="description">将生成的URL地址复制到小程序后台：“开发”——“开发设置”——“消息推送”——"启用"——"消息推动配置中"</div>
                    <el-form-item label="URL服务地址:">
                      <el-input v-model="url" disabled=""></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="description">将Token（令牌）和EncodingAESey配置到要绑定的微信公众平台后台</div>
                    <el-form-item label="Token（令牌）:" prop="token">
                      <el-input v-model="channelSet.token"></el-input>
                    </el-form-item>
                    <el-form-item label="encodingAesKey:" prop="encodingAesKey">
                      <el-input v-model="channelSet.encodingAesKey"></el-input>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="description">
                      消息加密方式——安全模式
                    </div>
                  </li>
                  <li>
                    <div class="description">
                      数据格式——XML
                    </div>
                  </li>
                </ul>
                <el-row type="flex" justify="center">
                  <el-button @click="lastStep">上一步</el-button>
                  <el-button type="primary" @click="save">保存</el-button>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'KeyAccess',
  data() {
    return {
      step: 1,
      bots: [{
        value: 'Bot1',
        label: '机器人1'
      }, {
        value: '选项2',
        label: '机器人2'
      }],
      channelSet: {
        name: '',
        appId: '',
        originId: '',
        appSecret: '',
        bot: '',
        triggerOn: true,
        triggerWord: '',
        greeting: '',
        routeStrategy: '',
        token: '',
        encodingAesKey: '',
        type: 0,
        platformId: 'miniprogram'
      },
      url: '',
      rules: {
        name: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入appId', trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: '请输入appSecret', trigger: 'blur' }
        ],
        greeting: [
          { required: true, message: '请输入欢迎语', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        triggerWord: [
          { required: true, message: '请输入转人工触发词', trigger: 'blur' }
        ],
        token: [
          { required: true, message: '请输入token', trigger: 'blur' },
          { min: 3, max: 32, message: '必须为英文或数字，长度为3-32字符', trigger: 'blur' }
        ],
        encodingAesKey: [
          { required: true, message: '请输入encodingAesKey', trigger: 'blur' },
          { min: 43, max: 43, message: '消息加密密钥由43位字符组成，字符范围为A-Z,a-z,0-9', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'channelSet.appId': function () {
      this.url = window.$envUtils('VUE_APP_BP_CHANNEL_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + window.$envUtils('VUE_APP_BP_CHANNEL_METHOD') + '/' + this.channelSet.appId + '?tenantId=' + this.$store.state.user.tenantId
    }
  },
  props: {
    channelSetParam: Object,
    strategies: Array
  },
  mounted() {
    this.channelSet.routeStrategy = this.strategies[0].id
    if (this.channelSetParam) {
      this.channelSet = this.channelSetParam
    } else {
      this.getToken()
      this.getASEKey()
      this.channelSet.bot = this.bots[0].value
    }
  },
  methods: {
    getToken() {
      this.channelSet.token = this.randomWord(true, 3, 32)
    },
    getASEKey() {
      this.channelSet.encodingAesKey = this.randomWord(false, 43)
    },
    randomWord(randomFlag, min, max) {
      var str = ''
      var range = min
      var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min
      }
      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    save() {
      this.$refs.form.validate((valid) => {
        var that = this
        this.channelSet.channelId = 'miniprogram'
        this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/set', {
          data: this.channelSet
        }).then(function (response) {
          if (response.code && response.code === 2000) {
            that.$message.success('保存成功!')
            that.$emit('changeView', 0)
          } else {
            that.$message.error(response.data.msg)
          }
        }).catch(function (error) {
          console.log(error)
        })
      })
    },
    cancel() {
      this.$emit('changeView', 0)
    },
    nextStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.step += 1
        } else {
          return false
        }
      })
    },
    lastStep() {
      this.step -= 1
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 60px);
}
.el-header {
  padding: 0;
  margin-bottom: 0;
  .title {
    margin-bottom: 0;
  }
}

.max-block {
  max-width: 800px;
  h4 {
    text-align: center;
    font-size: 20px;
    color: #333;
    margin-bottom: 35px;
  }

  .el-form-item {
    /*  &:last-child {
      margin-top: 60px;
    }*/

    ::v-deep .el-form-item__label {
      color: #333;
    }
    ::v-deep .el-form-item__content {
      .el-input,
      .el-textarea,
      .el-select {
        width: 85%;
        margin-right: 10px;
      }
      .el-select {
        .el-input {
          width: 100%;
        }
      }
      .el-row {
        width: 85%;
        .el-input,
        .el-textarea,
        .el-select {
          width: 100%;
          margin-right: 0;
        }
      }
    }
  }
  ::v-deep .el-form-item__content {
    .d-flex {
      display: flex;
      margin-bottom: 20px;
      .el-row {
        margin-right: 10px;
      }
      .el-button {
        & + .el-button {
          margin-left: 10px;
        }
      }
    }
  }
}

.el-tooltip__popper {
  max-width: 100px;
}
.el-header {
  height: auto !important;
  margin-bottom: 0;
  padding: 0;
  .title {
    margin-bottom: 0;
  }
}
.max-block {
  max-width: 800px;
  h4 {
    text-align: center;
    font-size: 20px;
    color: #333;
    margin-bottom: 35px;
  }
}

.el-alert {
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: 2px;
  font-size: 12px;
  margin-bottom: 30px;
  &.el-alert--warning.is-light {
    background-color: #fcf7f1;
    border-color: #ffeedc;
    color: #f66f6a;
  }
}
.docking-deploy {
  counter-reset: step;
  margin-left: 50px;
  margin-bottom: 40px;

  li {
    position: relative;

    &:before {
      content: counter(step);
      counter-increment: step;
      position: absolute;
      left: -45px;
      top: -3px;
      width: 30px;
      text-align: center;
      line-height: 30px;
      display: block;
      font-size: 16px;
      color: #fff;
      background: #52a3ff;
      border-radius: 50%;
    }

    &:not(:last-child):after {
      content: "";
      position: absolute;
      left: -32px;
      top: 32px;
      height: 100%;
      border: 2px dashed #bdbdbd;
    }

    .el-form-item {
      ::v-deep .el-form-item__label {
        font-size: 12px;
        color: #666;
      }
      ::v-deep .el-form-item__content {
        .el-input {
          width: 70%;
        }
      }
    }
  }
  .description {
    color: #111;
    font-size: 14px;
    margin-bottom: 20px;
    text-align: left;
    line-height: 2;
  }
}
</style>
